module.exports = __webpack_public_path__ + "img/LD+R_Thumb.a42473d0.jpg";